import { getGridStringOperators } from '@mui/x-data-grid-pro'

import { PaginatedBookingColumnType } from '../VoucherDataGrid'

export const codeColumnModel: PaginatedBookingColumnType = {
  field: 'code',
  width: 115,
  filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains' || operator.value === 'equals')
}
